import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';

const AddPlating = () => {
    const [formData, setFormData] = useState({
        staff_id: '',
        customer_name: '',
        net_weight_of_gold: '',
        description: '',
        pcs: '',
        laker: '',
        image: null,
    });
    const [staffList, setStaffList] = useState([]);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Fetch staff list on mount
    useEffect(() => {
        fetch('https://pbhrm.com/api/staff')
            .then((res) => res.json())
            .then((data) => {
                if (data.status === 1) {
                    setStaffList(data.data);
                } else {
                    console.error('Failed to load staff');
                }
            })
            .catch((err) => {
                console.error('Error fetching staff:', err);
            });
    }, []);

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'file' ? files[0] : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const {
            staff_id,
            customer_name,
            net_weight_of_gold,
            description,
            pcs,
            laker,
            image,
        } = formData;

        if (!staff_id || !customer_name || !net_weight_of_gold || !description || !pcs || !laker || !image) {
            setError('All fields are required');
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('staff_id', staff_id);
        formDataToSend.append('customer_name', customer_name);
        formDataToSend.append('net_weight_of_gold', net_weight_of_gold);
        formDataToSend.append('description', description);
        formDataToSend.append('pcs', pcs);
        formDataToSend.append('laker', laker);
        formDataToSend.append('image', image);

        try {
            const response = await fetch(`${BASE_URL}plating`, {
                method: 'POST',
                body: formDataToSend,
            });

            const data = await response.json();
            if (data.status === 1) {
                navigate('/PlatingList');
            } else {
                setError(data.error || 'Something went wrong');
            }
        } catch (error) {
            console.error('Error adding plating:', error);
            setError('An error occurred while adding plating');
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <h3>Add Plating Record</h3>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Select Staff</label>
                                        <select
                                            className="form-control"
                                            name="staff_id"
                                            value={formData.staff_id}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Select Staff</option>
                                            {staffList.map((staff) => (
                                                <option key={staff.id} value={staff.id}>
                                                    {staff.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Customer Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="customer_name"
                                            value={formData.customer_name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Net Weight of Gold</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="net_weight_of_gold"
                                            value={formData.net_weight_of_gold}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">PCS of Rhodium</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">PCS of Flash</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="pcs"
                                            value={formData.pcs}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Weight of Laker</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="laker"
                                            value={formData.laker}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Image</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="image"
                                            onChange={handleChange}
                                            accept="image/*"
                                            required
                                        />
                                    </div>

                                    <button type="submit" className="btn btn-primary">
                                        Add Plating
                                    </button>{' '}
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => navigate('/PlatingList')}
                                    >
                                        Back
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddPlating;
